import { AppShell, Group, Text, Container, Anchor } from '@mantine/core'
import { Link } from 'react-router-dom'
import { useI18n } from '@/hooks/useI18n'
import { useBranding } from '@/hooks/useBranding'

export const Footer: React.FC = () => {
    const { t } = useI18n()
    const { siteName } = useBranding()

    return (
        <AppShell.Footer p="md">
            <Container size="xl">
                <Group justify="space-between" align="center">
                    <Text size="sm" c="dimmed">
                        © 2025 {siteName}
                    </Text>
                    <Group gap="md">
                        <Anchor component={Link} to="/faq" size="sm" c="dimmed">
                            {t('faq.title')}
                        </Anchor>
                        <Anchor component={Link} to="/contact" size="sm" c="dimmed">
                            {t('nav.contact')}
                        </Anchor>
                    </Group>
                </Group>
            </Container>
        </AppShell.Footer>
    )
} 